import * as React from 'react'
import { HashFields, HiddenField, Label, Select, TextField } from 'react-rails-form-helpers'
import * as API from '../lib/api'

interface IProps {
  address: API.IAddress
  addressType: string
  stateSelectOptions: string[][]
  countrySelectOptions: string[][]
  toggleUseDefaultBillingAddress: () => void
  allowUsingDefault: boolean
  onAddressChanged: (field: AddressFormFields, value: string) => void
  title: string
}

export enum AddressFormFields {
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  State = 'state',
  Province = 'province',
  Zip = 'zip',
  Country = 'country',
}

export class AddressForm extends React.Component<IProps, object> {
  public isUSA() {
    const { address } = this.props
    const { country } = address

    return country === 'USA'
  }

  public stateSelectOptions() {
    const { stateSelectOptions } = this.props

    const stateOptions = stateSelectOptions.map(([_, value]) => {
      return <option key={value} value={value}>{value}</option>
    })

    return (stateOptions)
  }

  public countrySelectOptions() {
    const { countrySelectOptions } = this.props

    const countryOptions = countrySelectOptions.map(([name, value], index) => {
      return <option key={`${value}-${index}`} value={value}>{name}</option>
    })

    return (countryOptions)
  }

  public stateOrProvince() {
    const { address, addressType, onAddressChanged } = this.props
    const { state, province } = address

    if (this.isUSA()) {
      return (
        <React.Fragment>
          <Label htmlFor="state">State</Label>
          <Select
            name="state"
            autoComplete={`${addressType} address-level1`}
            required={true}
            defaultValue={state}
            onChange={(e) => onAddressChanged(AddressFormFields.State, e.target.value)}
          >
            <option value=""/>
            {this.stateSelectOptions()}
          </Select>
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <Label htmlFor="province">Province</Label>
        <TextField
          name="province"
          autoComplete={`${addressType} address-level1`}
          required={true}
          defaultValue={province}
          onChange={(e) => onAddressChanged(AddressFormFields.Province, e.target.value)}
        />
      </React.Fragment>
    )
  }

  public render() {
    const {
      address,
      addressType,
      allowUsingDefault,
      toggleUseDefaultBillingAddress,
      onAddressChanged,
      title,
    } = this.props
    const {
      address1,
      address2,
      city,
      zip,
      country,
    } = address

    return (
      <section className="address-form">
        <h2>{title}</h2>

        <HashFields name={`${addressType}_address`}>
          <Label htmlFor="country">Country</Label>
          <Select
            name="country"
            autoComplete={`${addressType} country`}
            required={true}
            defaultValue={country}
            onChange={(e) => onAddressChanged(AddressFormFields.Country, e.target.value)}
          >
            {this.countrySelectOptions()}
          </Select>

          <Label htmlFor="address1">Street Address 1</Label>
          <TextField
            name="address1"
            autoComplete={`${addressType} address-line1`}
            required={true}
            defaultValue={address1}
            onBlur={(e) => onAddressChanged(AddressFormFields.Address1, e.target.value)}
          />

          <Label htmlFor="address2">Street Address 2</Label>
          <TextField
            name="address2"
            autoComplete={`${addressType} address-line2`}
            defaultValue={address2}
            onBlur={(e) => onAddressChanged(AddressFormFields.Address2, e.target.value)}
          />

          <div className="grid-x">
            <div className="cell small-full large-24 large-padded">
              <Label htmlFor="city">City</Label>
              <TextField
                name="city"
                autoComplete={`${addressType} address-level2`}
                required={true}
                defaultValue={city}
                onBlur={(e) => onAddressChanged(AddressFormFields.City, e.target.value)}
              />
            </div>

            <div className="cell small-full large-36 large-padded">
              <div className="grid-x">
                <div className="cell small-30 large-33 small-padded">
                  {this.stateOrProvince()}
                </div>

                <div className="cell small-30 large-27 small-padded">
                  <Label htmlFor="zip">{this.isUSA() ? 'Zip Code' : 'Postal Code'}</Label>
                  <TextField
                    name="zip"
                    autoComplete={`${addressType} postal-code`}
                    required={true}
                    defaultValue={zip}
                    onBlur={(e) => onAddressChanged(AddressFormFields.Zip, e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </HashFields>

        <HiddenField name={`use_default_${addressType}_address`} value={false} />

        {allowUsingDefault ? <a onClick={() => toggleUseDefaultBillingAddress()}>Cancel</a> : null}
      </section>
    )
  }
}
